import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/layout/layout";
import IndexPage from "@/views/staticPages/homePage";
import indexError from "@/views/staticPages/homeError";
import indexUpdata from "@/views/staticPages/homeUpdata";
import Login from "@/views/login/login";
import { getLocal, checkNull } from "../filters/filters";
import router from "./../router";

//数据统计首页
import IndexAgent from "@/views/indexStatistic/indexAgent";
import IndexMerchant from "@/views/indexStatistic/indexMerchant";

// 上传完税证明错误信息展示
import TaxUploadErrRes from "@/views/staticPages/taxUploadErrRes";

// 线上合同签署
import FillInInformation from "@/views/onlineContractSign/fillInInformation";

// 找回密码
import FindPassword from "@/views/login/findPassword";

/**
 * 选择账号
 * */
import SelectAcc from "@/views/selectAccount/selectAccount";

/**
 * 数据管理模块
 * BSendStatistics： 商户下发统计
 * CSendStatistics： 用户下发统计
 * AgentSendStatistics：代理下发统计
 * */

// 元素表
import DomStandard from "@/views/staticPages/domStandard";

/**
 * 资金下发管理- （原交易中心）
 * */
//资金下发管理_批次数据准备
const BatchDataanceList = () => import("@/views/dealManage/dme_batchData");
//资金下发管理——批次数据准备_查看 详细信息
const BatchDataDetails = () =>
  import("@/views/dealManage/dme_batchDataDetails");
//资金下发管理——批次数据准备_批次数据提交
const BatchSubmission = () =>
  import("@/views/dealManage/dme_batchDataSubmission");
//资金下发管理_批次明细交易信息查询
const BatchInformation = () =>
  import("@/views/dealManage/dme_batchInformation");
//用户管理_用户信息管理
const UserControl = () => import("@/views/dealManage/dme_userControl");
//用户管理_签约协议查看
const userAgreement = () => import("@/views/dealManage/dem_userAgreement");
//个体户信息管理
const IndBusinessInfoManage = () =>
  import("@/views/dealManage/dme_indBusinessInfoManage");
// 多批次数据准备
const MultipleBatchesDataList = () =>
  import("@/views/dealManage/dme_multipleBatchesData");
//资金下发管理——多批次数据准备_批次数据提交
const MultipleBatchesSubmission = () =>
  import("@/views/dealManage/dme_multipleBatchesSubmission");
//资金下发管理——多批次数据准备_查看 详细信息
const MultipleBatchesDataDetail = () =>
  import("@/views/dealManage/dme_multipleBatchesDataDetail");
//个体户订单管理
const PersonalOrderList = () =>
  import("@/views/dealManage/dem_personalOrderList");
//个体户订单管理
const ServiceChargeList = () =>
  import("@/views/dealManage/dem_serviceChargeList");

/**
 * 财务中心
 * */
const BalanceManage = () => import("@/views/financeManage/fam_balanceManage");
const rechargeRecord = () => import("@/views/financeManage/fam_rechargeRecord");
const electronicReceipt = () =>
  import("@/views/financeManage/fam_electronicReceipt");
const TaxProveList = () => import("@/views/financeManage/fam_taxProveList");
//完税证明详情
const TaxProveDetail = () => import("@/views/financeManage/fam_taxProveDetail");
const InvoiceDetail = () => import("@/views/financeManage/fam_invoiceDetail");
// 付款账户管理
const PayAccountManage = () =>
  import("@/views/financeManage/fam_payAccountManage");
//子公司余额管理
const SubsidiaryBalanceList = () =>
  import("@/views/financeManage/fam_subsidiaryBalanceList");
//发票申请
const InvoiceApply = () => import("@/views/financeManage/fam_invoiceApply");
//开票记录
const BillingRecordList = () =>
  import("@/views/financeManage/fam_billingRecordList");
// 开票申请
const BillingApply = () => import("@/views/financeManage/fam_billingApply");
// 开票信息
const BillingInfo = () => import("@/views/financeManage/fam_billingInfo");
// 管理费退还记录
const FeeRefundRecordList = () =>
  import("@/views/financeManage/feeRefundRecordList");

/**
 * 数据中心
 * */
//收款用户交易统计
const ReceivableTransactionStatistics = () =>
  import("@/views/dataCenter/dac_ReceivableTransactionStatistics");
//收款用户交易统计详情
const ReceivableDetails = () =>
  import("@/views/dataCenter/dac_ReceivableDetails");
const AgentTransactionStatistics = () =>
  import("@/views/dataCenter/dac_AgentTransactionStatistics");

// 代理商历史交易统计
const AgentTransactionStatisticsHistory = () =>
  import("@/views/dataCenter/dac_AgentTransactionStatisticsHistory");
//代理//代理商用户统计商用户统计详情
const AgentDetails = () => import("@/views/dataCenter/dac_AgentDetails");
//代理//代理商用户历史统计商用户统计详情
const AgentDetailsHistory = () =>
  import("@/views/dataCenter/dac_AgentDetailsHistory");
//商户交易统计
const BusinessStatistics = () =>
  import("@/views/dataCenter/dac_BusinessStatistics");
//商户交易统计详情
const BusinessDetails = () => import("@/views/dataCenter/dac_BusinessDetails");
// 月环比数据
const MonthOnMonthStatis = () =>
  import("@/views/dataCenter/dac_monthOnMonthStatis");
// 历史用工结算明细
const HistoryEmploymentInfoList = () =>
  import("@/views/dataCenter/historyEmploymentInfoList");
// 佣金结算订单
const AgentBrokerageSettleRecord = () =>
  import("@/views/dataCenter/agentBrokerageSettleRecord");
// 提现详情
const WithdrawalDetail = () => import("@/views/dataCenter/withdrawalDetail");

/**
 * 管理中心
 * */
//账户管理
const selCooChildAccount = () =>
  import("@/views/accountManagement/amemt_selCooChildAccount");
//账户管理-编辑权限
const selChildAccProbablyMsg = () =>
  import("@/views/accountManagement/amemt_selChildAccProbablyMsg");
//账户管理-重置密码
const resetAccountPwd = () =>
  import("@/views/accountManagement/amemt_resetAccountPwd");
// 接口对接
const openapiButtJoint = () =>
  import("@/views/accountManagement/amemt_openapiButtJoint");
// 功能配置
const funConfig = () => import("@/views/accountManagement/amemt_funConfig");
// 合同管理
const ContractDownload = () =>
  import("@/views/accountManagement/contractDownload");
// 经办人管理
const OperatorManage = () => import("@/views/accountManagement/operatorManage");

/**
 * 商户管理
 * */
const CoopList = () => import("@/views/coopManage/coopList.vue"); // 商户列表
const customerResearch = () => import("@/views/coopManage/customerResearch"); //客户公海池
const OemConfig = () => import("@/views/coopManage/oemConfig");

/**
 * 消息管理
 * */
const NoticeList = () => import("@/views/noticeManage/noticeList.vue"); //消息列表
const NoticeListDetail = () =>
  import("@/views/noticeManage/noticeListDetail.vue"); //消息列表

/**
 * 用工中心
 * */
const taskList = () => import("@/views/employManage/taskList"); // 招聘列表，原任务管理
const bulkInvitation = () => import("@/views/employManage/bulkInvitation"); // 批量邀请
const taskApplyInfo = () => import("@/views/employManage/taskApplyInfo"); // 报名详情
const taskCreateAndInfo = () =>
  import("@/views/employManage/taskCreateAndUpdate"); // 新建任务 + 任务编辑
const RecycleBinList = () => import("@/views/employManage/recycleBinList"); // 回收站列表
const EmploymentStatement = () =>
  import("@/views/employManage/employmentStatement"); // 用工结算单
const EmploymentStatementSubmit = () =>
  import("@/views/employManage/employmentStatementSubmit"); // 用工结算单提交
const EmploymentSubmitAppeal = () =>
  import("@/views/employManage/employmentSubmitAppeal");
const PeaceOfMindSign = () => import("@/views/employManage/peaceOfMindSign"); // 安心签
const EmploymentStatementDetail = () =>
  import("@/views/employManage/employmentStatementDetail"); // 用工结算单详情
const EmployeeInfoDesc = () => import("@/views/employManage/employeeInfoDesc"); // 用工明细表
const DistributeInfoDesc = () =>
  import("@/views/employManage/distributeInfoDesc"); // 下发明细
const EditEmployeeInfoDesc = () =>
  import("@/views/employManage/editEmployeeInfoDesc"); // 编辑用工明细表
const EmploymentStatementDesc = () =>
  import("@/views/employManage/employmentStatementDesc"); //用工结算明细
const FeeRefundDesc = () => import("@/views/employManage/feeRefundDesc"); // 管理费退还明细
const ProfessionalList = () => import("@/views/employManage/professionalList"); // 自由职业者列表
const ProofDocumentsList = () =>
  import("@/views/employManage/proofDocumentsList"); // 证明类文件
const MissionStatement = () => import("@/views/employManage/missionStatement"); // 任务说明书
const InfoDifferentialData = () =>
  import("@/views/employManage/infoDifferentialData"); //收款信息差异数据
const ComplianceCenter = () => import("@/views/employManage/complianceCenter"); //合规中心

const ShiftScheduling = () => import("@/views/employManage/shiftScheduling"); //灵工管理
const LaborConfirmation = () =>
  import("@/views/employManage/laborConfirmation"); //用工确认
const LaborConfirmationDetail = () =>
  import("@/views/employManage/laborConfirmationDetail"); //用工确认详情
const EmploymentRoster = () => import("@/views/employManage/employmentRoster"); //用工花名册
const AttendanceManagement = () =>
  import("@/views/employManage/attendanceManagement"); //考勤管理
const DeliveryRecord = () => import("@/views/employManage/deliveryRecord"); //考勤管理
const CalculateTool = () => import("@/views/employManage/calculateTool"); //测算工具
const CalculateDetail = () => import("@/views/employManage/calculateDetail"); //测算工具详情

/**
 * 任务中心 -- 针对江西慧用工
 * */
const TaskCenList = () => import("@/views/taskCenter/taskCenList"); // 任务中心列表
const TaskDetail = () => import("@/views/taskCenter/taskDetail"); // 任务详情

/**
 * 系统公共页面 - 导出记录
 * */
const ExportRecordsList = () =>
  import("@/views/systemPublicManage/exportRecordsList"); // 导出记录

/**
 * 优惠券中心
 */
const DiscountCouponManageList = () =>
  import("@/views/discountCouponManage/discountCouponManageList"); // 优惠券管理列表
const CouponUsageDetail = () =>
  import("@/views/discountCouponManage/couponUsageDetail"); // 使用明细

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        title: "登录"
      },
      beforeEnter: (to, from, next) => {
        if (checkNull(localStorage.getItem("resOemInfo"))) {
          to.meta.title = "";
        } else {
          to.meta.title = getLocal("resOemInfo").clientName;
        }
        next();
      }
    },
    //多批次处理后完税证明错误结果展示
    {
      path: "/taxUploadErrRes",
      name: "tax-res",
      component: TaxUploadErrRes,
      meta: {
        title: "错误结果展示"
      }
    },

    {
      path: "/fillInInformation",
      name: "fill-in-information",
      component: FillInInformation,
      meta: {
        title: "线上合同签署"
      }
    },

    // 找回密码
    {
      path: "/findPassword",
      name: "find-password",
      component: FindPassword,
      meta: {
        title: "找回密码"
      }
    },

    {
      path: "/selectAcc",
      component: SelectAcc,
      name: "select-acc",
      meta: {
        title: "选择账号"
      }
    },

    {
      path: "/layOut", // layout页面
      name: "home-page",
      component: Home,
      children: [
        {
          path: "/home", // welcome首页
          name: "index",
          component: IndexPage,
          meta: {
            title: "首页"
          },
          redirect: to => {
            let userMeg = JSON.parse(getLocal("userMessage"));
            if (userMeg) {
              // 代理商：40；商户：10，20，30，55
              if (userMeg.companyType == "40") {
                // 代理商
                return "/indexAg";
              } else {
                return "/indexMer";
              }
            } else {
              // 登录页面
              return "/";
            }
          }
        },
        // welcome首页，自然人代开用户
        {
          path: "/indexWelcome",
          name: "index",
          component: IndexPage,
          meta: {
            title: "首页"
          }
        },

        // 商户首页，人力资源和生产力平台商户
        {
          path: "/indexMer",
          name: "index_merchant",
          component: IndexMerchant,
          meta: {
            title: "首页",
            auth: true
          }
        },

        // 代理商首页，人力资源和生产力平台代理商
        {
          path: "/indexAg",
          name: "index_agent",
          component: IndexAgent,
          meta: {
            title: "首页",
            auth: true
          }
        },

        {
          path: "/error",
          name: "error",
          component: indexError,
          meta: {
            auth: true
          }
        },
        {
          path: "/updata",
          name: "error",
          component: indexUpdata,
          meta: {
            auth: true
          }
        },

        //发票申请
        {
          path: "/invoiceApply",
          name: "invoice-apply",
          component: InvoiceApply,
          meta: {
            title: "发票申请",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/batchDataDetails",
          name: "dem_batchDataDetails",
          component: BatchDataDetails,
          meta: {
            title: "批次数据准备详情",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              },
              {
                name: "批次数据准备",
                path: ""
              }
            ]
          }
        },
        {
          path: "/batchData",
          name: "dme_batchData",
          component: BatchDataanceList,
          meta: {
            title: "批次数据准备",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/serviceChargeList",
          name: "dme-service-charge-List",
          component: ServiceChargeList,
          meta: {
            title: "服务费明细列表",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/multipleBatchesData",
          name: "dme_multipleBatchesData",
          component: MultipleBatchesDataList,
          meta: {
            title: "多批次数据准备",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/multipleBatchesSubmission",
          name: "dme_multipleBatchesSubmission",
          component: MultipleBatchesSubmission,
          meta: {
            title: "多批次数据准备",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/multipleBatchesDataDetail",
          name: "dme_multipleBatchesDataDetail",
          component: MultipleBatchesDataDetail,
          meta: {
            title: "多批次数据准备",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/batchmation",
          name: "dme_batchmation",
          component: BatchInformation,
          meta: {
            title: "批次明细交易信息查询",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/batchSubmission",
          name: "dme_batchSubmission",
          component: BatchSubmission,

          meta: {
            title: "批次数据准备",
            auth: true,
            breadcrumb: [
              {
                name: "资金下发管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/userControl",
          name: "dme_UserControl",
          component: UserControl,
          meta: {
            title: "自由职业者信息管理",
            auth: true,
            breadcrumb: [
              {
                name: "自由职业者管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/userAgreement",
          name: "dme_UserAgreement",
          component: userAgreement,
          meta: {
            title: "自由职业者签约状态",
            auth: true,
            breadcrumb: [
              {
                name: "自由职业者管理",
                path: ""
              }
            ]
          }
        },
        //个体户订单管理
        {
          path: "/personalOrderList",
          name: "dme_personalOrderList",
          component: PersonalOrderList,
          meta: {
            title: "个体户订单管理",
            auth: true,
            breadcrumb: [
              {
                name: "自由职业者管理",
                path: ""
              }
            ]
          }
        },
        //个体户信息管理
        {
          path: "/indBusinessInfoManage",
          name: "dme_indBusinessInfoManage",
          component: IndBusinessInfoManage,
          meta: {
            title: "个体户信息管理",
            auth: true,
            breadcrumb: [
              {
                name: "自由职业者管理",
                path: ""
              }
            ]
          }
        },

        //财务中心
        {
          path: "/balanceManage",
          name: "fam_balanceManage",
          component: BalanceManage,
          meta: {
            title: "余额管理",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        // 管理费退还记录
        {
          path: "/feeRefundRecordList",
          name: "fam_feeRefundRecordList",
          component: FeeRefundRecordList,
          meta: {
            title: "管理费退还记录",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "余额管理",
                path: ""
              }
            ]
          }
        },
        {
          path: "/rechargeRecord",
          name: "fam_rechargeRecord",
          component: rechargeRecord,
          meta: {
            title: "充值记录",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/electronicReceipt",
          name: "fam_electronicReceipt",
          component: electronicReceipt,
          meta: {
            title: "电子回单",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/taxProveList",
          name: "fam_taxProveList",
          component: TaxProveList,
          meta: {
            title: "完税证明",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/taxProveDetail",
          name: "fam_taxProveDetail",
          component: TaxProveDetail,
          meta: {
            title: "完税证明详情",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "完税证明",
                path: ""
              }
            ]
          }
        },
        {
          path: "/subsidiaryBalanceList",
          name: "fam_subsidiaryBalanceList",
          component: SubsidiaryBalanceList,
          meta: {
            title: "子公司余额管理",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/invoiceDetail",
          name: "invoice-detail",
          component: InvoiceDetail,
          meta: {
            title: "开票详情",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "充值记录",
                path: ""
              }
            ]
          }
        },

        {
          path: "/payAccountManage",
          name: "fam_pay-account-manage",
          component: PayAccountManage,
          meta: {
            title: "付款账户管理",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "商户余额管理",
                path: ""
              }
            ]
          }
        },

        {
          path: "/billingRecordList",
          name: "billing-record-list",
          component: BillingRecordList,
          meta: {
            title: "开票记录",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              }
            ]
          }
        },

        {
          path: "/billingApply",
          name: "billing-apply",
          component: BillingApply,
          meta: {
            title: "开票申请",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "开票记录",
                path: ""
              }
            ]
          }
        },

        {
          path: "/billingInfo",
          name: "billing-info",
          component: BillingInfo,
          meta: {
            title: "开票信息管理",
            auth: true,
            breadcrumb: [
              {
                name: "财务中心",
                path: ""
              },
              {
                name: "开票记录",
                path: ""
              }
            ]
          }
        },

        {
          path: "/ReceivableTransactionStatistics",
          name: "dac_ReceivableTransactionStatistics",
          component: ReceivableTransactionStatistics,
          meta: {
            title: "自由职业者结算统计",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/ReceivableDetails",
          name: "dac_ReceivableDetails",
          component: ReceivableDetails,
          meta: {
            title: "自由职业者结算统计详情",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/AgentTransactionStatistics",
          name: "dac_AgentTransactionStatistics",
          component: AgentTransactionStatistics,
          meta: {
            title: "代理商交易统计",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/AgentTransactionStatisticsHistory",
          name: "dac_AgentTransactionStatisticsHistory",
          component: AgentTransactionStatisticsHistory,
          meta: {
            title: "代理商历史交易统计",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/AgentDetailsHistory",
          name: "dac_AgentDetailsHistory",
          component: AgentDetailsHistory,
          meta: {
            title: "代理商历史交易统计详情",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/AgentDetails",
          name: "dac_AgentDetails",
          component: AgentDetails,
          meta: {
            title: "代理商交易统计详情",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/BusinessStatistics",
          name: "dac_BusinessStatistics",
          component: BusinessStatistics,
          meta: {
            title: "商户结算统计",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/BusinessDetails",
          name: "dac_BusinessDetails",
          component: BusinessDetails,
          meta: {
            title: "商户结算统计详情",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        // 月环比数据
        {
          path: "/monthOnMonthStatis",
          name: "dac_monthOnMonthStatis",
          component: MonthOnMonthStatis,
          meta: {
            title: "月环比数据",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },
        // 数据中心 - 历史用工结算明细
        {
          path: "/historyEmploymentInfoList",
          name: "history-employment-info-list",
          component: HistoryEmploymentInfoList,
          meta: {
            title: "历史用工结算明细",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },

        // 数据中心 - 佣金结算订单
        {
          path: "/agentBrokerageSettleRecord",
          name: "dac_AgentBrokerageSettleRecord",
          component: AgentBrokerageSettleRecord,
          meta: {
            title: "佣金结算订单",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              }
            ]
          }
        },

        // 数据中心 - 佣金结算订单 - 提现详情
        {
          path: "/withdrawalDetail",
          name: "withdrawal-detail",
          component: WithdrawalDetail,
          meta: {
            title: "提现详情",
            auth: true,
            breadcrumb: [
              {
                name: "数据中心",
                path: ""
              },
              {
                name: "佣金结算订单",
                path: ""
              }
            ]
          }
        },

        {
          path: "/selCooChildAccount",
          name: "amemt_selCooChildAccount",
          component: selCooChildAccount,
          meta: {
            title: "账号管理",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/selChildAccProbablyMsg",
          name: "amemt_selChildAccProbablyMsg",
          component: selChildAccProbablyMsg,
          meta: {
            title: "编辑权限",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/resetAccountPwd",
          name: "amemt_resetAccountPwd",
          component: resetAccountPwd,
          meta: {
            title: "重置密码",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/openapiButtJoint",
          name: "amemt_openapiButtJoint",
          component: openapiButtJoint,
          meta: {
            title: "接口对接",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/funConfig",
          name: "amemt_funConfig",
          component: funConfig,
          meta: {
            title: "功能配置",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/contractDownload",
          name: "contract-download",
          component: ContractDownload,
          meta: {
            title: "合同管理",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/operatorManage",
          name: "operator-manage",
          component: OperatorManage,
          meta: {
            title: "经办人管理",
            auth: true,
            breadcrumb: [
              {
                name: "管理中心",
                path: ""
              },
              {
                name: "合同管理",
                path: ""
              }
            ]
          }
        },

        {
          path: "/taskList",
          name: "task-list",
          component: taskList,
          meta: {
            title: "任务列表",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/bulkInvitation",
          name: "bulk-invitation",
          component: bulkInvitation,
          meta: {
            title: "批量邀请",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "任务列表",
                path: "/taskList"
              }
            ]
          }
        },
        {
          path: "/taskApplyInfo",
          name: "task-apply-info",
          component: taskApplyInfo,
          meta: {
            title: "报名详情",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/shiftScheduling",
          name: "shift-scheduling",
          component: ShiftScheduling,
          meta: {
            title: "排班管理",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "任务列表",
                path: ""
              }
            ]
          }
        },
        {
          path: "/laborConfirmation",
          name: "labor-confirmation",
          component: LaborConfirmation,
          meta: {
            title: "用工确认",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "任务列表",
                path: ""
              }
            ]
          }
        },
        {
          path: "/laborConfirmationDetail",
          name: "labor-confirmation-detail",
          component: LaborConfirmationDetail,
          meta: {
            title: "用工确认详情",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "任务列表",
                path: ""
              }
            ]
          }
        },
        {
          path: "/employmentRoster",
          name: "employment-roster",
          component: EmploymentRoster,
          meta: {
            title: "用工花名册",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/attendanceManagement",
          name: "attendance-management",
          component: AttendanceManagement,
          meta: {
            title: "考勤记录",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/deliveryRecord",
          name: "delivery-record",
          component: DeliveryRecord,
          meta: {
            title: "交付记录",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/recycleBinList",
          name: "recycle-bin-list",
          component: RecycleBinList,
          meta: {
            title: "回收站",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        // 合规中心
        {
          path: "/complianceCenter",
          name: "compliance-center",
          component: ComplianceCenter,
          meta: {
            title: "任务信息维护",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/taskCreateAndUpdate",
          name: "task-create-and-info",
          component: taskCreateAndInfo,
          meta: {
            title: "发布任务",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },

        {
          path: "/employmentStatement",
          name: "employment-statement",
          component: EmploymentStatement,
          meta: {
            title: "用工结算单",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },

        {
          path: "/employmentStatementSubmit",
          name: "employment-statement-submit",
          component: EmploymentStatementSubmit,
          meta: {
            title: "提交结算单",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算单",
                path: ""
              }
            ]
          }
        },

        {
          path: "/employmentSubmitAppeal",
          name: "employment-submit-appeal",
          component: EmploymentSubmitAppeal,
          meta: {
            title: "申诉",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算单",
                path: ""
              },
              {
                name: "提交结算单",
                path: ""
              }
            ]
          }
        },

        {
          path: "/peaceOfMindSign",
          component: PeaceOfMindSign,
          meta: {
            title: "安心签开户",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算单",
                path: ""
              },
              {
                name: "提交结算单",
                path: ""
              }
            ]
          }
        },
        {
          path: "/editEmployeeInfoDesc",
          name: "edit-employee-info-desc",
          component: EditEmployeeInfoDesc,
          meta: {
            title: "编辑用工明细表",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算单",
                path: ""
              }
            ]
          }
        },
        {
          path: "/employmentStatementDetail",
          name: "employment-statement-detail",
          component: EmploymentStatementDetail,
          meta: {
            title: "结算单详情",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算单",
                path: ""
              }
            ]
          }
        },
        {
          path: "/employmentStatementDesc",
          name: "employment-statement-desc",
          component: EmploymentStatementDesc,
          meta: {
            title: "用工结算明细",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },

        {
          path: "/employeeInfoDesc",
          name: "employee-info-desc",
          component: EmployeeInfoDesc,
          meta: {
            title: "用工明细表",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算明细",
                path: ""
              }
            ]
          }
        },
        // 管理费退还明细
        {
          path: "/feeRefundDesc",
          name: "fee-refund-desc",
          component: FeeRefundDesc,
          meta: {
            title: "管理费退还明细",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算明细",
                path: ""
              }
            ]
          }
        },

        // 下发明细
        {
          path: "/distributeInfoDesc",
          name: "distribute-info-desc",
          component: DistributeInfoDesc,
          meta: {
            title: "用工明细表",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "用工结算明细",
                path: ""
              }
            ]
          }
        },
        // 自由职业者列表
        {
          path: "/professionalList",
          name: "professional-list",
          component: ProfessionalList,
          meta: {
            title: "自由职业者列表",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        {
          path: "/infoDifferentialData",
          name: "info-differential-data",
          component: InfoDifferentialData,
          meta: {
            title: "收款信息差异数据",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },

        // 证明类文件
        {
          path: "/proofDocumentsList",
          name: "proof-documents-list",
          component: ProofDocumentsList,
          meta: {
            title: "证明类文件",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "自由职业者列表",
                path: ""
              }
            ]
          }
        },
        // 任务说明书
        {
          path: "/missionStatement",
          name: "mission-statement",
          component: MissionStatement,
          meta: {
            title: "任务说明书",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        // 测算工具
        {
          path: "/calculateTool",
          name: "calculate-tool",
          component: CalculateTool,
          meta: {
            title: "测算工具",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              }
            ]
          }
        },
        // 测算单详情
        {
          path: "/calculateDetail",
          name: "calculate-detail",
          component: CalculateDetail,
          meta: {
            title: "测算详情",
            auth: true,
            breadcrumb: [
              {
                name: "用工中心",
                path: ""
              },
              {
                name: "测算工具",
                path: ""
              }
            ]
          }
        },

        {
          path: "/DomStandard",
          name: "dom-standard",
          component: DomStandard,
          meta: {
            title: "元素标准"
          }
        },

        /**
         * 商户管理
         * */
        {
          path: "/coopList",
          name: "coop-list",
          component: CoopList,
          meta: {
            title: "商户列表",
            auth: true,
            breadcrumb: [
              {
                name: "商户管理",
                path: ""
              }
            ]
          }
        },
        //客户公海池
        {
          path: "/customerResearch",
          name: "dom-customerResearch",
          component: customerResearch,
          meta: {
            title: "商户公海池",
            auth: true,
            breadcrumb: [
              {
                name: "商户管理",
                path: ""
              }
            ]
          }
        },
        // oem配置
        {
          path: "/oemConfig",
          name: "oem-config",
          component: OemConfig,
          meta: {
            title: "oem配置",
            auth: true,
            breadcrumb: [
              {
                name: "商户管理",
                path: ""
              }
            ]
          }
        },

        /**
         * 消息列表
         * */
        {
          path: "/noticeList",
          name: "notice-list",
          component: NoticeList,
          meta: {
            title: "消息列表",
            auth: true,
            breadcrumb: [
              {
                name: "首页",
                path: ""
              }
            ]
          }
        },

        /**
         * 消息列表详情
         * */
        {
          path: "/noticeListDetail",
          name: "notice-list-detail",
          component: NoticeListDetail,
          meta: {
            title: "消息详情",
            auth: true,
            breadcrumb: [
              {
                name: "首页",
                path: ""
              },
              {
                name: "消息列表",
                path: ""
              }
            ]
          }
        },

        //任务中心 - 任务列表
        {
          path: "/taskCenList",
          name: "task-cen-list",
          component: TaskCenList,
          meta: {
            title: "任务中心",
            auth: true,
            breadcrumb: [
              {
                name: "任务列表",
                path: ""
              }
            ]
          }
        },

        //任务中心 -- 任务详情
        {
          path: "/taskDetail",
          name: "task-detail",
          component: TaskDetail,
          meta: {
            title: "任务中心",
            auth: true,
            breadcrumb: [
              {
                name: "任务列表",
                path: ""
              },
              {
                name: "任务详情",
                path: ""
              }
            ]
          }
        },

        /**
         * 优惠券管理
         */
        // 优惠券管理
        {
          path: "/discountCouponManageList",
          name: "discount-coupon-manage-list",
          component: DiscountCouponManageList,
          meta: {
            title: "优惠券管理",
            breadcrumb: [
              {
                name: "优惠券中心",
                path: ""
              }
            ]
          }
        },
        // 使用明细
        {
          path: "/couponUsageDetail",
          name: "coupon-usage-detail",
          component: CouponUsageDetail,

          meta: {
            title: "使用明细",
            breadcrumb: [
              {
                name: "优惠券中心",
                path: ""
              },
              {
                name: "优惠券管理",
                path: ""
              }
            ]
          }
        },

        // 公共页面 - 导出记录
        {
          path: "/exportRecordsList",
          name: "export-records-list",
          component: ExportRecordsList,
          meta: {
            title: "导出记录"
          }
        }
      ]
    },
    {
      path: "*", // 找不到路由，跳转登录
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js